import { Component, Input, inject } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ShiveContextMenuService } from '../../../../core/services/controls/shive-context-menu.service';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ContextMenuItem } from '../../../data-types/context-menu-item-type';

@Component({
  selector: 'app-shive-grid',
  templateUrl: './shive-grid-wrapper.component.html',
  standalone: false,
})
export class ShiveGridWrapperComponent {
  @Input() grid: GridComponent;
  public userOperation = UserOperation.None;
  public contextMenuItems: ContextMenuItem[] = [];
  private readonly shiveContextMenuService = inject(ShiveContextMenuService);

  public openContextMenu(anchor: HTMLDivElement, data: any): void {
    this.shiveContextMenuService.openContextMenu(
      anchor,
      this.contextMenuItems,
      data,
      this.userOperation,
    );
  }
}
